var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "support-entries-component" },
    [
      _vm.routeDocHref
        ? _c(
            "div",
            { staticClass: "text-center pa-1" },
            [
              _c("DocumentationButton", { attrs: { path: _vm.routeDocHref } }, [
                _vm._v("\n      Page documentation\n    ")
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "VList",
        [
          _c(
            "VListTile",
            { on: { click: _vm.onSearchDoc } },
            [
              _c(
                "VListTileAvatar",
                [_c("KmIcon", { attrs: { name: "km-icon-search" } })],
                1
              ),
              _vm._v(" "),
              _c("VListTileTitle", { staticClass: "doc-search-tile-title" }, [
                _vm._v("\n        Search documentation\n      ")
              ])
            ],
            1
          ),
          _vm._v(" "),
          _vm.showRestoreAppcues
            ? _c(
                "VListTile",
                { on: { click: _vm.restoreAppcues } },
                [
                  _c(
                    "VListTileAvatar",
                    [_c("KmIcon", { attrs: { name: "km-icon-check" } })],
                    1
                  ),
                  _vm._v(" "),
                  _c("VListTileTitle", { staticClass: "text--text" }, [
                    _vm._v("\n        Restore onboarding\n      ")
                  ])
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "VListTile",
            {
              attrs: {
                href: "https://github.com/keymetrics/pm2-plus-tech-questions",
                target: "_blank"
              }
            },
            [
              _c(
                "VListTileAvatar",
                [_c("KmIcon", { attrs: { name: "km-icon-team" } })],
                1
              ),
              _vm._v(" "),
              _c("VListTileTitle", { staticClass: "text--text" }, [
                _vm._v("\n        Community support\n      ")
              ])
            ],
            1
          ),
          _vm._v(" "),
          _vm.hasPremiumSupport && !_vm.isDedicated
            ? _c(
                "VListTile",
                { on: { click: _vm.onOpenZendesk } },
                [
                  _c(
                    "VListTileAvatar",
                    [_c("KmIcon", { attrs: { name: "km-icon-support" } })],
                    1
                  ),
                  _vm._v(" "),
                  _c("VListTileTitle", { staticClass: "text--text" }, [
                    _vm._v("\n        Open a support ticket\n      ")
                  ])
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isDedicated
            ? _c(
                "VListTile",
                {
                  attrs: {
                    href: "mailto:tech@pm2.io?subject=[Dedicated support]"
                  }
                },
                [
                  _c(
                    "VListTileAvatar",
                    [_c("KmIcon", { attrs: { name: "km-icon-support" } })],
                    1
                  ),
                  _vm._v(" "),
                  _c("VListTileTitle", { staticClass: "text--text" }, [
                    _vm._v("\n        Contact PM2 tech team\n      ")
                  ])
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }